import { LuLock } from 'react-icons/lu';

interface GrowthToggleProps {
    growthView: 'portfolio' | 'pinned';
    onViewSwitch: (view: 'portfolio' | 'pinned') => void;
    isEditing?: boolean;
}

export const GrowthToggle = ({ growthView, onViewSwitch, isEditing = false }: GrowthToggleProps) => {
    if (!isEditing) {
        // In view mode, show the selected option with a lock icon for the non-selected
        return (
            <div className="rounded-lg border border-gray-300 bg-gray-100 p-0.5 shadow-sm">
                <div className="flex">
                    <button
                        className={`rounded-md px-2 py-1 text-xs font-medium transition-all duration-200 ${
                            growthView === 'portfolio'
                                ? 'text-cocoa-1000 bg-[rgb(188,237,237)] shadow-sm'
                                : 'cursor-default text-gray-400'
                        } font-halyard flex min-w-[60px] items-center justify-center`}
                        disabled={!isEditing}
                    >
                        {growthView === 'portfolio' ? 'Portfolio' : <LuLock className="h-4 w-4" />}
                    </button>
                    <button
                        className={`rounded-md px-2 py-1 text-xs font-medium transition-all duration-200 ${
                            growthView === 'pinned'
                                ? 'text-cocoa-1000 bg-[rgb(188,237,237)] shadow-sm'
                                : 'cursor-default text-gray-400'
                        } font-halyard flex min-w-[90px] items-center justify-center`}
                        disabled={!isEditing}
                    >
                        {growthView === 'pinned' ? 'Pinned to Accounts' : <LuLock className="h-4 w-4" />}
                    </button>
                </div>
            </div>
        );
    }

    // In edit mode, show the regular toggle behavior
    return (
        <div className="rounded-lg border border-gray-300 bg-gray-100 p-0.5 shadow-sm">
            <div className="flex">
                <button
                    onClick={() => onViewSwitch('portfolio')}
                    className={`rounded-md px-2 py-1 text-xs font-medium transition-all duration-200 ${
                        growthView === 'portfolio'
                            ? 'text-cocoa-1000 bg-[rgb(188,237,237)] shadow-sm'
                            : 'text-gray-400 hover:text-gray-600'
                    } font-halyard`}
                >
                    Portfolio
                </button>
                <button
                    onClick={() => onViewSwitch('pinned')}
                    className={`rounded-md px-2 py-1 text-xs font-medium transition-all duration-200 ${
                        growthView === 'pinned'
                            ? 'text-cocoa-1000 bg-[rgb(188,237,237)] shadow-sm'
                            : 'text-gray-400 hover:text-gray-600'
                    } font-halyard`}
                >
                    Pinned to Accounts
                </button>
            </div>
        </div>
    );
};
